import Constants from '../constants';
import produce from "immer";
import { UpdateArray, UpdateArrayRange } from '../misc/ArrayFuncs';


const initDataState = [];
const StarchKitchenItems = (state = initDataState, action) => {
    switch (action.type) {
        //Add
        case Constants.Actions.StarchKitchenItem.Add:
            return UpdateArray(action.payload, state);
        case Constants.Actions.StarchKitchenItem.Add_Rollback:
            const skiID = state.findIndex(iv => iv.id === action.meta.newSKItem.id);
            if (skiID !== -1) {
                return produce(state, pd => { pd.splice(skiID, 1) });
            } else {
                return state;
            }
        case Constants.Actions.StarchKitchenItem.Add_Commit:
            return UpdateArray(action.payload?.data, state);
        case Constants.Actions.StarchKitchenItem.ClearData:
            return initDataState;
        //Update
        case Constants.Actions.StarchKitchenItem.Update:
            return UpdateArray(action.payload.update, state);
        case Constants.Actions.StarchKitchenItem.Update_Commit:
            return UpdateArray(action.payload?.data, state);
        case Constants.Actions.StarchKitchenItem.Update_Rollback:
            return UpdateArray(action.meta.data.current, state);
        //Get
        case Constants.Actions.StarchKitchenItem.GetByVisitID:
            return UpdateArrayRange(action.data, state);
        case Constants.Actions.StarchKitchenItem.Delete:
            return UpdateArray(produce(action.payload, d => {
                d.deleted = true;
            }), state);
        case Constants.Actions.StarchKitchenItem.Delete_Commit:
            return state;
        case Constants.Actions.StarchKitchenItem.Delete_Rollback:
            return UpdateArray(action.meta.delSKItem, state);
        default:
            return state;
    }
}
export default StarchKitchenItems;